<template>
    <b-card class="my-3 shadow-sm thick-border" :border-variant="question.correct ? 'success' : 'danger'">
        <b-card-text>
            <!-- Display question body and whether it's correct or not -->
            <b-container fluid>
                <b-row no-gutters :class="{ 'pb-3': !selectedSurveyObject.isEvaluated }">
                    <b-col cols="12">
                        <h5 class="display-breaks text-justify"><strong>{{ number }}.</strong> {{ question.body }}</h5>
                    </b-col>
                </b-row>

                <b-row v-if="selectedSurveyObject.isEvaluated" no-gutters>
                    <b-col cols="11" offset="1">
                        <p>
                            Ponderación: <strong>{{ question.valueDisplay }} %</strong>
                        </p>
                    </b-col>
                </b-row>
            </b-container>
        </b-card-text>
    </b-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'SurveyAnswer',
    props: {
        question: Object,
        number: Number
    },
    computed: {
        ...mapState([
            'selectedSurveyObject'
        ])
    }
}
</script>
